import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  Table,
  Row,
  Col,
  Form,
  Input,
} from 'reactstrap';
import { MappingState } from '../../../features/ingest/ingestSlice';
import MappingActions from '../../../features/ingest/mappingActions';
import ColumnSelector from './ColumnSelector';

const TableSmall = styled(Table)`
  font-size: 10px;
`;

export const EventType = {
  Header: 1,
  Column: 2,
  Clear: 3,
};

export default (state: MappingState) => {   
    const actions = new MappingActions(useDispatch());  
    const rows = state.previewRows;
    const mapping = state.mapping;

    return (
      <>
        <Row>
          <Col style={{ textAlign: 'right' }}>
            <Form style={{ margin: '1em' }}>
              <Input
                type="checkbox"
                onChange={() => { actions.toggleHeader()}}
                checked={state.hasHeader}
              ></Input>
              Contains Header Row
            </Form>
          </Col>
        </Row>
        <div className="tpicap-mapeditor-body">
          <TableSmall hover>
            <thead>
              <tr>
                {rows[0].map((field, i) => (
                  //eslint-disable-next-line
                  <th key={`field-${i}`}>
                    <div style={{ overflow: 'hidden' }}>
                      <ColumnSelector
                        position={i}
                        onSelected={(col) => {actions.update(i,col)}}
                        onClear={() => {actions.clear(i)}}
                        selection={mapping[i]}
                        schema={state.schema}
                      />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, j) => (
                <tr
                  //eslint-disable-next-line
                  key={`row-${j}`}
                  className={
                    j === 0 && state.hasHeader ? 'tpicap-row-ignore' : ''
                  }
                >
                  {row.map((field, i) => (
                    //eslint-disable-next-line
                    <td key={`row-${j}-field-${i}`}>{field}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </TableSmall>
        </div>
      </>
    );  
}
